import { useParams } from 'react-router';

import { AkaThemaId } from '../dtos';

type Params = {
  akaThemaId?: AkaThemaId;
  akaProduktId?: string;
  akaVeranstaltungId?: string;
  akaDurchgangId?: string;
};

export const useNormalizedParams = () => useParams<Params>();
